// import ColorThief from "colorthief/dist/color-thief.mjs";
import { classExists } from "../helper/class-exists";
import { clickButton } from "../helper/click-button";

const detectScrollbarX = (elem) => {
  return elem.scrollWidth > elem.clientWidth;
};

const tableTrader = () => {
  const tableElems = document.querySelectorAll(".js-table-trader");
  const bodyElem = document.querySelector("body");
  if (tableElems.length <= 0) {
    return;
  }

  tableElems.forEach((tableElem) => {
    let tableFirst = tableElem.querySelectorAll(".first-fixed");
    let tableLast = tableElem.querySelectorAll(".last");

    let tableFlagContainer = tableElem.querySelectorAll(".js-trader-flags");
    let tableFlagButton = tableElem.querySelectorAll(".js-trader-flags button");
    let tableContainerPattern = tableElem.querySelector(".js-table-pattern");

    for (let i = 0; i < tableFirst.length; i++) {
      let logoWidth = 140 + 48;

      if (bodyElem.classList.contains("mobile-active")) {
        logoWidth = 110 + 24;
      }

      let sideHalfWidth =
        (window.innerWidth - tableContainerPattern.offsetWidth) / 2;
      let firstWidth = sideHalfWidth + logoWidth;

      tableFirst[i].style.width = firstWidth + "px";
      tableFirst[i].style.minWidth = firstWidth + "px";

      tableLast[i].style.width = 0; //reset

      if (tableFlagButton[i]) {
        tableFlagButton[i].addEventListener("click", function (event) {
          tableFlagContainer[i].classList.toggle("is-open");
        });
      }
    }

    for (let a = 0; a < tableFirst.length; a++) {
      let tableMain = tableElem.querySelector("table");
      let remainingWidth = window.innerWidth - tableMain.offsetWidth;

      let lastDiv = tableLast[a].querySelector(".last-elem");

      // const computed = remainingWidth + 100;
      let computed = remainingWidth + lastDiv.offsetWidth;
      tableLast[a].style.width = computed + "px";
    }

    const tableScrollbar = tableElem.querySelector(".table-container");

    // detect scrollbar
    if (detectScrollbarX(tableScrollbar)) {
      tableElem.querySelector(".title-text")?.classList.add("has-scrollbar");
    } else {
      tableElem.querySelector(".title-text")?.classList.remove("has-scrollbar");
    }

    let buttonContainer = tableElem.querySelector(".scrollbar-buttons");
    if (buttonContainer) {
      let buttons = buttonContainer.querySelectorAll("button");
      let scrollingPower = buttonContainer.dataset.scrollPower;

      for (let b = 0; b < buttons.length; b++) {
        buttons[b].addEventListener("click", function (event) {
          if (this.classList.contains("next")) {
            tableScrollbar.scrollBy({
              top: 0,
              left: scrollingPower,
              behavior: "smooth",
            });
          } else {
            tableScrollbar.scrollBy({
              top: 0,
              left: -1 * scrollingPower,
              behavior: "smooth",
            });
          }
        });
      }
    }
  });
};

const tableNotif = () => {
  const elems = document.querySelectorAll(".js-table-notif");
  classExists(elems);

  for (let i = 0; i < elems.length; i++) {
    const notifButton = elems[i].querySelector(".close");

    clickButton([notifButton], (button, i) =>
      elems[i].classList.add("is-hidden")
    );
  }
};

const toggleClassOnScroll = (menuSelector, sectionClass, className) => {

  const section = document.querySelector(sectionClass);

  classExists(section);

  if(!section.classList.contains('is-header-fixed')) {
    return;
  }

  const menu = document.querySelector(menuSelector);
  const tableElem = section.querySelector(".table-container");
  const mainMenu = document.querySelector(".js-menu-scroll");
  if (!menu || !section) return;


  const theadWrapper = tableElem.querySelector('thead tr');
  const tbodyWrapper = tableElem;

  tbodyWrapper.addEventListener('scroll', () => {
    theadWrapper.scrollLeft = tbodyWrapper.scrollLeft;
  });

  theadWrapper.addEventListener('scroll', () => {
    tbodyWrapper.scrollLeft = theadWrapper.scrollLeft;
  });

  window.addEventListener('scroll', () => {
    const menuBottom = menu.getBoundingClientRect().bottom;
    const tableTop = tableElem.getBoundingClientRect().top;
    const tableBottom = tableElem.getBoundingClientRect().bottom;

    if (menuBottom >= tableTop && menuBottom <= tableBottom) {
      tableElem.classList.add(className);
      if (!mainMenu.classList.contains('is-scrolling')) {
        tableElem.classList.add('menu-visible');
      } else {
        tableElem.classList.remove('menu-visible');
      }
    } else {
      tableElem.classList.remove(className);
      tableElem.classList.remove('menu-visible');
    }
  });
};

document.addEventListener("DOMContentLoaded", function () {
  tableTrader();
  // applyBrokerDominantColor();
  horizontalToplistListener();
  compareCheckboxRedirect();
  tableNotif();
  sortTraderTable();
  infoRatingScroll();
  triggerCompareModalFromBrokerCardMobile();

  toggleClassOnScroll(".js-table-contents", ".js-table-trader", "is-fixed");
});

window.addEventListener(
  "resize",
  (event) => {
    tableTrader();
    horizontalToplistListener();
  },
  true
);

// // determine dominant color for each row of each horizontal toplist table and apply a color on the left
// const applyBrokerDominantColor = () => {
//   const allTables = document.querySelectorAll(
//     ".js-table-trader .table-container table"
//   );
//   allTables.forEach((tableContainer) => {
//     // get all table cell broker image of each table row
//     let brokerImgEls = tableContainer.querySelectorAll(
//       "tr > td .table-logo figure a img"
//     );
//     brokerImgEls.forEach((brokerImg) => {
//       let colorThief = new ColorThief();
//       let colors = [];
//       try {
//         if (brokerImg.complete) {
//           colors = colorThief.getColor(brokerImg); // rgb in array
//           brokerImg.closest("td").style =
//             "--table-color: " + rgbToHex(colors[0], colors[1], colors[2]) + ";";
//         } else {
//           brokerImg.addEventListener("load", () => {
//             colors = colorThief.getColor(brokerImg);
//             brokerImg.closest("td").style =
//               "--table-color: " +
//               rgbToHex(colors[0], colors[1], colors[2]) +
//               ";";
//           });
//         }
//       } catch (error) {
//         console.log(error);
//       }
//     });
//   });
// };

const horizontalToplistListener = () => {
  const allTables = document.querySelectorAll(
    ".js-table-trader .table-container table"
  );
  if (allTables.length) {
    allTables.forEach((table) => {
      new MutationObserver((mutations) => {
        if (mutations.length > 0) {
          tableTrader();
          // applyBrokerDominantColor();
        }
      }).observe(table, { childList: true, subtree: true });
    });
  }
};

const compareCheckboxRedirect = () => {
  let compareCheckboxes = document.querySelectorAll(".compare-checkbox");
  if (compareCheckboxes.length <= 0) {
    return; // no need to process checkbox comparison
  }
  const maxComparison = 2;
  compareCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("click", function () {
      let currentlyChecked = document.querySelectorAll(
        ".compare-checkbox:checked"
      );
      if (currentlyChecked.length === maxComparison) {
        let comparisonURL = currentlyChecked[0].dataset.comparisonUrl;
        let broker1Slug = currentlyChecked[0].dataset.brokerIdentifier;
        let broker2Slug = currentlyChecked[1].dataset.brokerIdentifier;
        let comparisonSlug = broker1Slug + "-vs-" + broker2Slug;
        window.location.href = comparisonURL + comparisonSlug;
      }
    });
  });
};

// convert rgb numbers to hex
const rgbToHex = (r, g, b) =>
  "#" +
  [r, g, b]
    .map((x) => {
      const hex = x.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    })
    .join("");

const sortTraderTable = () => {
  let sortColumns = document.querySelectorAll(".js-sort-table");
  if (sortColumns.length) {
    [...sortColumns].forEach((sortColumn, i) => {
      sortColumn.addEventListener("click", (event) => {
        let sortColumnEl = event.target.parentNode.parentNode;
        let tableContainer = sortColumnEl.parentNode.parentNode.parentNode;
        let tbodyContainer = tableContainer.querySelector(
          ".scroll-table-container"
        );
        let sortPropertyType = sortColumnEl.dataset.property_type;
        let sortCurrentOrder = sortColumnEl.dataset.initial_sort_order;
        let sortNextOrder = sortCurrentOrder === "ASC" ? "DESC" : "ASC";
        sortColumnEl.setAttribute("data-initial_sort_order", sortNextOrder);
        let data = JSON.parse(
          atob(sortColumnEl.closest("table").dataset.postlist_identifier)
        );
        data.sorting = {};
        data["sorting"][sortPropertyType] = sortNextOrder;
        lsApi.getPosts(
          { list_configuration: data, is_sort_request: true },
          (jqxhr, status) => {
            if (status !== "success") {
              console.log("Error fetching tableSort order");
              return;
            }

            let orderedRows = [];
            let response = JSON.parse(jqxhr.responseText);
            // sort the values
            response.posts.forEach((row) => {
              let rowIdentifier = row.post_identifier;
              let currentRow = tbodyContainer.querySelector(
                '[data-post_identifier="' + rowIdentifier + '"]'
              );
              orderedRows.push(currentRow);
            });
            tbodyContainer.innerHTML = ""; // clear the table rows
            // reinsert the ordered rows
            orderedRows.forEach((orderedRow) => {
              tbodyContainer.append(orderedRow);
            });
          }
        );
      });
    });
  }
};

const infoRatingScroll = () => {
  let infoRatingButtons = document.querySelectorAll(".info-rating");
  if (infoRatingButtons.length) {
    infoRatingButtons.forEach((infoRatingButton) => {
      infoRatingButton.addEventListener("click", (event) => {
        let infoRatingParentContainer =
          event.target.closest(".award-broker-card");
        let ratingChartContainer =
          infoRatingParentContainer.nextElementSibling.nextElementSibling
            .nextElementSibling.nextElementSibling;
        let y =
          ratingChartContainer.getBoundingClientRect().top +
          window.pageYOffset -
          100;
        window.scrollTo({ top: y, behavior: "smooth" });
      });
    });
  }
};

const triggerCompareModalFromBrokerCardMobile = () => {
  let brokerCardMobileCompareButtons =
    document.querySelectorAll(".trigger-compare");
  if (brokerCardMobileCompareButtons.length) {
    brokerCardMobileCompareButtons.forEach((compareButtons) => {
      compareButtons.addEventListener("click", (event) => {
        let thisCompareButton = event.target;

        let compareBrokerData = JSON.parse(
          atob(thisCompareButton.dataset.compareBrokerData)
        );
        let compareBrokerMobileModal = document.getElementById(
          "compare-modal-broker-card"
        );
        compareBrokerMobileModal
          .querySelector(".compare-modal-broker-card-img")
          .setAttribute("src", compareBrokerData.image);
        compareBrokerMobileModal
          .querySelector(".compare-modal-broker-card-img")
          .setAttribute("alt", compareBrokerData.title);
        compareBrokerMobileModal.querySelector(
          ".compare-modal-broker-card-title"
        ).innerHTML = compareBrokerData.complete_title.format(
          compareBrokerData.title
        );
        let compareToOtherBrokersOption =
          "<option selected disabled>" +
          compareBrokerData.default_compare_option +
          "</option>";
        compareBrokerData.compare_links.forEach((cb) => {
          compareToOtherBrokersOption +=
            '<option value="' + cb.href_link + '">' + cb.name + "</option>;";
        });
        compareBrokerMobileModal.querySelector(
          ".compare-modal-dropdown-broker-card-mobile"
        ).innerHTML = compareToOtherBrokersOption;
      });
    });
  }
};

// lazy load youtube subscribe button
window.addEventListener("load", () => {
  let subscribeEl = document.querySelector(".channel-script");
  if (subscribeEl) {
    setTimeout(() => {
      let detachedSubscribeEl =
        subscribeEl.parentElement.removeChild(subscribeEl);
      let subscribeContainers = document.querySelectorAll(
        ".subscribe-container"
      );
      [...subscribeContainers].forEach((subscribeContainer) => {
        let clonedSubscriberEl = detachedSubscribeEl.cloneNode(true);
        clonedSubscriberEl.classList.remove("hidden");
        let clonedIframe = clonedSubscriberEl.querySelector("iframe");
        clonedIframe.setAttribute("loading", "lazy");
        clonedIframe.setAttribute(
          "title",
          subscribeContainer.dataset.awardLabel
        );
        subscribeContainer.appendChild(clonedSubscriberEl);
      });
    }, 200);
  }
});
